import { Component, OnInit } from '@angular/core';
import { PermissionService } from '../../service/permission/permission.service';
import { Permission } from '../../class/permission';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public permissions: Permission[];
    public selectPermission: Permission;
    public userID: Number = 0;
    public modNew = false;
    public modView = false;
    public openPermission = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public permissionService: PermissionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getPermissions();
        this.page = 1;
        this.per_page = 10;
    }

    public loadPermissionsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getPermissions(event.globalFilter);
    }

    public getPermissions(query?: string) {
        this.permissionService.getPermission(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.permissions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newPermission() {
        this.modNew = !this.modNew;
        this.selectPermission = null;
    }

    public savedPermission(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectPermission = null;
        this.modNew = false;
        this.getPermissions();
    }

    public cancelPermission (res) {
        this.selectPermission = null;
        this.modNew = false;
        this.modView = false;
        this.getPermissions();
    }

    public edit(user: Permission) {
        this.modNew = true;
        this.selectPermission = user;
        this.getPermissions();
    }

    public view(user: Permission) {
        this.openPermission = true;
        this.selectPermission = user;
        this.userID = user.id;
        this.modView = true;
    }

    public deleteDialog(user: Permission) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(user);
            }
        });
    }

    public delete(user: Permission) {
        this.permissionService.deletePermission(user.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getPermissions();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activePermission(user: Permission) {
        this.putPermission(user);
    }

    public putPermission(values: Permission) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.permissionService.updatePermission(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/permissions/permissions.component.ts